export const environment = {
	companyName: '',
	production: false,
	apiUrl: 'https://vm26644.vpsone.xyz:5001',
	// apiUrl: 'http://109.248.213.88:5001',
};
